import { useParams } from '@fs/zion-router'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { H5 } from '@fs/zion-ui'
import { usePageView } from '@fs/zion-analytics'
import useGroup from '../../hooks/useGroup'
import SubnavAndRoutes from '../app/SubnavAndRoutes'
import GroupContextProvider from './GroupContextProvider'
import GroupMembers from './members/GroupMembers'
import GroupReservations from './reservations/GroupReservations'
import MetaData from '../metadata/MetaData'
import GroupSummary from './summary/GroupSummary'
import { PermissionsContext } from '../app/PermissionsContext'
import GroupChanges from './changes/GroupChanges'
import { usePageTitle } from '../app/PageTitleContext'

export default function GroupBase() {
  usePageView({ page_detail: 'DMConsole:GroupBase' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.group.base'))
  const { isRole } = useContext(PermissionsContext)
  const params = useParams()
  const groupId = params.groupId
  const { currentGroupData, fetchCurrentGroupData } = useGroup(groupId)
  const groupContext = { currentGroupData, fetchCurrentGroupData }

  const subNavs = [
    {
      text: t('summary', 'Summary'),
      path: `summary`,
      requiredPermissions: 'FtLoginPermission',
      component: GroupSummary,
    },
  ]

  subNavs.splice(1, 0, {
    text: t('changes', 'Changes'),
    path: `changes`,
    requiredPermissions: 'FtLoginPermission',
    component: GroupChanges,
  })

  if (!currentGroupData?.tombstoned) {
    subNavs.splice(1, 0, {
      text: t('groupMembersLabel', 'Members ({count})', {
        count: currentGroupData ? currentGroupData.memberCount : 0,
      }),
      path: `members`,
      requiredPermissions: 'FtLoginPermission',
      component: GroupMembers,
    })
  }
  if (currentGroupData?.chatChannelCid) {
    subNavs.splice(2, 0, {
      text: t('messages.label', 'New Messages'),
      path: `chat/${currentGroupData.chatChannelCid}/messages`,
      requiredPermissions: 'FtLoginPermission',
      nonParentUrl: true,
    })
  }
  subNavs.splice(2, 0, {
    text: t('groupReservationsLabel', 'Reservations ({count})', {
      count: currentGroupData ? currentGroupData.reservationCount : 0,
    }),
    path: `reservations`,
    requiredPermissions: 'FtLoginPermission',
    component: GroupReservations,
  })

  if (!isRole(['Engineer Admin', 'Data Admin 4', 'Data Admin 5', 'Data Admin 6'])) {
    return <H5>{t('not.authorized.greeting', 'Not authorized')}</H5>
  }

  if (!groupId) {
    return t('group.baseMessage', 'Look up a group to view group data')
  }
  if (!currentGroupData) {
    return null
  }

  return (
    <GroupContextProvider value={groupContext}>
      <MetaData metadata={currentGroupData.metadata} />
      <SubnavAndRoutes data={subNavs} />
    </GroupContextProvider>
  )
}
